const topics = [
  {
    key: 'funding',
    slug: 'funding',
    title: 'Funding',
    isPrimary: true,
    colorHexCode: '#38908A',
  },
  {
    key: 'pitch_deck',
    slug: 'pitch-deck',
    title: 'Pitch Deck',
    isPrimary: true,
    colorHexCode: '#4A47A3',
  },
  {
    key: 'customer_acquisition',
    slug: 'customer-acquisition',
    title: 'Customer Acquisition',
    isPrimary: true,
    colorHexCode: '#46B5D1',
  },
  {
    key: 'idea_validation',
    slug: 'idea-validation',
    title: 'Idea Validation',
    isPrimary: true,
    colorHexCode: '#385564',
  },
  {
    key: 'product_mvp',
    slug: 'product-mvp',
    title: 'Product/MVP',
    isPrimary: true,
    colorHexCode: '#3B79BF',
  },
  {
    key: 'emotional_support',
    slug: 'emotional-support',
    title: 'Emotional Support',
    isPrimary: true,
    colorHexCode: '#7F6084',
  },
  {
    key: 'peer_networking',
    slug: 'peer-networking',
    title: 'Networking',
    isPrimary: true,
    colorHexCode: '#872341',
  },
  {
    key: 'recruiting',
    slug: 'recruiting',
    title: 'Recruiting',
    isPrimary: true,
    colorHexCode: '#C0553E',
  },
  {
    key: 'strategy',
    slug: 'strategy',
    title: 'Strategy',
    isPrimary: true,
    colorHexCode: '#A43D5C',
  },

  {
    key: 'general',
    title: 'General',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'marketing',
    title: 'Marketing',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'sales',
    title: 'Sales',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'talent',
    title: 'Talent',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'apps',
    title: 'Apps',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'b2b',
    title: 'B2B',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'bizdev',
    title: 'BizDev',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'branding',
    title: 'Branding',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'content_creation',
    title: 'Content Creation',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'copywriting',
    title: 'Copywriting',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'customer_discovery',
    title: 'Customer Discovery',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'customers',
    title: 'Customers',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'd2c',
    title: 'D2C',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'data',
    title: 'Data',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'elevator_pitch',
    title: 'Elevator Pitch',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'emotional_intelligence',
    title: 'Emotional Intelligence',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'finance',
    title: 'Finance',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'growth',
    title: 'Growth',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'health',
    title: 'Health',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'human_resources',
    title: 'Human Resources',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'influencer_marketing',
    title: 'Influencer Marketing',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'it',
    title: 'IT',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'legal',
    title: 'Legal',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'mvp',
    title: 'MVP',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'no_code',
    title: 'No-Code',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'operations',
    title: 'Operations',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'scaling',
    title: 'Scaling',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'social_media',
    title: 'Social Media',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'value_proposition',
    title: 'Value Proposition',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
  {
    key: 'cpg',
    title: 'CPG',
    isPrimary: false,
    colorHexCode: '#5F7495',
  },
].map(topic => ({
  ...topic,
  slug: topic.slug || topic.key.replaceAll('_', '-'), // catchall to map keys to equivalent slug in CMS (uses hyphens vs underscores)
}))

export const primaryTopics = topics.filter(t => t.isPrimary)

export { topics as default }
